import api from '@/api'

const state = {
  fuelPrices: [],
  fuelPricesDownload: {}
}

const getters = {
  fuelPrices: state => state.fuelPrices,
  fuelPricesDownload: state => state.fuelPricesDownload
}

const mutations = {
  SET_FUEL_PRICES(state, payload) {
    state.fuelPrices = payload
  },
  SET_FUEL_PRICES_DOWNLOAD(state, payload) {
    state.fuelPricesDownload = payload
  }
}

const actions = {
  async fetchFuelPrices({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        ...payload
      }
      const { data } = await api.getFuelPrices(filter)

      if (data.error) {
        commit('SET_FUEL_PRICES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
      commit('SET_FUEL_PRICES', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error
    }
  },
  async fetchFuelPricesForDuplicateCheck({}, { start_date, end_date }) {
    const { data } = await api.getFuelPrices({
      page: 1,
      limit: 1,
      start_date,
      end_date
    })
    if (data.error) {
      if (data.error.code === 40410) {
        return []
      } else {
        throw new Error(data.error.message || 'Failed to verify duplicate date')
      }
    }
    return data.data || []
  },
  async addFuelPrice({}, payload) {
    try {
      await api.postFuelPrice(payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async editFuelPrice({}, payload) {
    try {
      await api.putFuelPrice(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async downloadFuelPrices({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getFuelPricesExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_FUEL_PRICES_DOWNLOAD', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetFuelPricesDownload({ commit }) {
    commit('SET_FUEL_PRICES_DOWNLOAD', {})
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
